module.exports = __webpack_public_path__ + "img/decoration-cloud-big-white.8b9f479b.svg";